$(document).ready(function ($) {

	$('body').on('click', 'a.ajax', function () {
		$(this).myAjax($(this).data('to-inject'));
		return false;
	});
	$('body').on('submit', 'form.ajax', function () {
		$(this).myAjax($(this).data('to-inject'));
		return false;
	});

	$('body').on('click', 'a.ajax-form-submit', function () {
		const formSel = $(this).data('form'),
			form = $(formSel),
			data = $(this).data('to-inject');
		if(form.length) {
			form.myAjax(data);
			return false;
		}
	});
});

//send form or href click via ajax
//on forms allows injection or change of values
$.fn.myAjax = function (toInject) {
	var url = null;
	var requestData = null;
	var form = null;
	if (this.prop('tagName').toLowerCase() == 'form') {
		form = this.closest('form');
		url = form.attr('action');
		if (typeof toInject === 'object') {
			for (var key in toInject) {
				//change a value if element exits
				if ($("input[name='" + key + "']", form).length > 0) {
					$("input[name='" + key + "']", form).val(toInject[key]);
				} else {//or insert a new one if it doesn't
					if (toInject.hasOwnProperty(key)) {
						$('<input>').attr({
							type: 'hidden',
							id: key,
							name: key,
							value: toInject[key]
						}).appendTo(form);
					}
				}
			}
		}
		requestData = form.serializeArray();
		if (form.prop('enctype') == 'multipart/form-data') {
			var formData = new FormData();
			for (var p in requestData) {
				formData.append(requestData[p].name, requestData[p].value);
			}
			jQuery.each($('input[type=file]', form), function (i, input) {
				if (input.files.length) {
					formData.append(input.name, input.files[0]);
				}
			});
			requestData = formData;
		}
		if (this.attr('data-persist-to-hash')) {
			disableHashChange = true;
			//add formId element with id value
			$('<input>').attr({type: 'hidden', name: 'formId', value: this.attr('id')}).appendTo(form);

			window.location.hash = '#' + $.param($('#' + this.attr('id')).values());
		}
		// persist data to GET parameters
		else if(this.attr('data-persist')) {
			const values = $(this).values();
			const url = location.protocol + '//' + location.host + location.pathname;
			const urlWithParams = url + '?'+$.param(values);
			window.history.pushState(null, null, urlWithParams); 
		}
	} else {
		url = this.attr('href');
		requestData = toInject;
		if (this.attr('data-persist-to-hash') && this.attr('id')) {
			disableHashChange = true;
			window.location.hash = '#' + this.attr('id');
		}
		else if (this.attr('data-persist')) {
			window.history.pushState(null, null, url); 
		}
	}

	$('.loader-overlay').show();

	var ajaxOptions = {
		url: (url) ? url : window.location.href,
		type: (form === null) ? 'GET' : 'POST',
		data: requestData
	};
	if (form && form.prop('enctype') == 'multipart/form-data') {
		ajaxOptions.contentType = false;
		ajaxOptions.processData = false;
		ajaxOptions.cache = false;
	}

	var hideLoader = true;
	const elements = [];
	$.ajax(ajaxOptions).done(function (responseData) {
		//handle snippets
		const popup = null;
		var evalScript = null;
		const index = null;
		
		if (typeof responseData !== 'object') {
			responseData = JSON.parse(responseData);
		}
		for (var key in responseData.snippets) {
			switch (responseData.snippets[key].type) {
				case 'element':
					{
						const element = $(key).html(responseData.snippets[key].body);
						elements.push(element);
					}
					break;
				case 'element-append':
					{
						const element = $(key).append(responseData.snippets[key].body);
						elements.push(element);
					}
					break;
				case 'popup':
					{
						const popup = responseData.snippets[key].body;
						elements.push(popup);
					}
					break;
				case 'popup-close':
					{
						$.fancybox.close();
					}
					break;
				case 'redirect':
					{
						document.location.href = responseData.snippets[key].body;
						hideLoader = false;
					}
					break;
				case 'redirect-ajax':
					{
						var url = responseData.snippets[key].body;
						var trigger = $('<a href="' + url + '" class="ajax"></a>').appendTo('body');
						trigger.click();
						trigger.remove();
						hideLoader = false;
					}
					break;
				case 'remove':
					{
						if (typeof responseData.snippets[key].body === 'object') {
							for (index in responseData.snippets[key].body) {
								$(responseData.snippets[key].body[index]).remove();
							}
						} else {
							$(responseData.snippets[key].body).remove();
						}
					}
					break;
				case 'hide':
					{
						if (typeof responseData.snippets[key].body === 'object') {
							for (index in responseData.snippets[key].body) {
								$(responseData.snippets[key].body[index]).hide();
							}
						} else {
							$(responseData.snippets[key].body).hide();
						}
					}
					break;
				case 'show':
					{
						if (typeof responseData.snippets[key].body === 'object') {
							for (index in responseData.snippets[key].body) {
								$(responseData.snippets[key].body[index]).show();
							}
						} else {
							$(responseData.snippets[key].body).show();
						}
					}
					break;
				case 'populate':
					{
						if ($(key).length && $(key).is('form')) {
							$(key).values(responseData.snippets[key].body.data, responseData.snippets[key].body.prefix);
							if ($(key).attr('data-js-validation')) {
								$(key).valid();
							}
						}
					}
					break;
				case 'eval':
					{
						evalScript = responseData.snippets[key].body;
					}
					break;
			}
			//reload on null snippet
			//if (responseData[key] == null) window.location.reload();
		}
		//check if there was a popup
		if (popup !== null) {
			$('.loader-overlay').hide();
			if ($.fn.fancybox) {
				$.fancybox.open(popup, defaultFancyboxConfig);
			}
		}
		//check if there was an eval
		if (evalScript !== null) {
			eval(evalScript);
		}
	}).fail(function () {
		alert('That is an error.');
	}).always(function () {
		afterAjax(elements);

		if (hideLoader) {
			$('.loader-overlay').hide();
		}
	});
};

function afterAjax(elements)
{
	//updateUploadWidgets();

	initJsValidation();

	// Stejná výška elementů
	$(window).resize();

	// Close FM
	initCloseFM();

	$(elements).each(function() {
		const itemSlider = $(this).find('.item-slider');
		if(itemSlider.length) {
			initItemSliders(itemSlider);
		}

		$(this).find('.sh-trig').toggler();
		$(this).find('.show-more').toggler({
			hideTrigger: true
		});
		$(this).find('.accordion__trigger').toggler({
			slide: true
		});
	});

	initModals('.modal-trigger');
	initGalleries('.glightbox');

	initForms();

	initTruncateTogglers('.truncate-toggle');
}
